import * as React from 'react';

function Lock({ isClosed = false }) {
  const imagePath = isClosed ? '/Images/lockClosed.png' : '/Images/lockOpen.png';

  return (
    <img
      src={imagePath}
      alt={isClosed ? 'Lock Closed' : 'Lock Open'}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      }}
    />
  );
}

export default Lock;
  